import { Component, OnInit } from '@angular/core';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { TranslateService } from '@ngx-translate/core';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { SearchToolbarFactoryParameters, SearchToolbarDateFunction, SearchToolbarFilterWindow, SearchToolbarFilterGrouping, SearchToolbarSection } from '../../../../models/search-toolbar-factory-parameters.model';

@Component({
  selector: 'app-store-customers-loyalty',
  templateUrl: './store-customers-loyalty.component.html',
  styleUrls: ['./store-customers-loyalty.component.css']
})
export class StoreCustomersLoyaltyComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];

  translations: any;

  incidenzaChart: LoyaltyChart;
  scontrinoMedioChart: LoyaltyChart;

  public storeError = false;
  public selectOneError: string;

  public data: QFilterModel;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) {
    this.translate.get([
      'loyalty_chart.incidenza_carta',
      'loyalty_chart.scontrino_medio',
      'loyalty_chart.axis_title_week',
      'loyalty_chart.axis_title_pct',
      'loyalty_chart.axis_title_eur',
      'loyalty_chart.period',
    ]).subscribe((t) => {
      this.translations = {
        indicenzaChartTitle: t['loyalty_chart.incidenza_carta'],
        scontrinoMedioChartTitle: t['loyalty_chart.scontrino_medio'],
        etichetta_week: t['loyalty_chart.axis_title_week'],
        etichetta_pct: t['loyalty_chart.axis_title_pct'],
        etichetta_eur: t['loyalty_chart.axis_title_eur'],
        period: t['loyalty_chart.period'],
      };
      this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });
      this.initCharts();
    });

  }

  initCharts() {
    this.incidenzaChart = (new LoyaltyChart('line', '%'));
    this.incidenzaChart.options.xAxis.title.text = this.translations.period;

    this.scontrinoMedioChart = new LoyaltyChart('line', '€');
    this.scontrinoMedioChart.options.xAxis.title.text = this.translations.period;
  }

  ngOnInit() {

  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValue (data: QFilterModel) {
    this.data = data;

    if (data['stores'] != null) {
      this.translate.get([
        'indicator.fatturato',
        'indicator.scontrini',
        'indicator.fatturato_mq',
        'indicator.scontrino_medio',
        'indicator.media_clienti_settimanali',
        'indicator.incidenza_carta',
        'indicator.incidenza_promo',
        'indicator.nuovi_clienti',
        'indicator.pct_clienti_target'
      ]).subscribe(t => {
        this.indicators = [];
        this.indicatorService.indicatorCalculation('stores.Q077', this.data).switchMap((res) => {

          this.indicators.push(new IndicatorBoxModel([res.find(r => r.name === 'incidenza_carta')], {unit_period_prec: '%'}, t));
          this.indicators.push(new IndicatorBoxModel([res.find(r => r.name === 'media_clienti_settimanali')], {decimal_value: 0, decimal_prec_value: 0}, t));

        return this.indicatorService.indicatorCalculation('stores.Q084', this.data);
        }).switchMap((res) => {
          this.indicators.push(new IndicatorBoxModel(res, {decimal_value: 0, decimal_prec_value: 0}, t));
        return this.indicatorService.indicatorCalculation('stores.Q105', this.data);
        }).subscribe((res) => {
          this.indicators.push(new IndicatorBoxModel(res, {unit_period_prec: '%', decimal_value: 2}, t));
        });
      });

      this.chartsService.loadChart(this.incidenzaChart, 'stores.Q106', data, this.indicatorService, this.translate);
      this.chartsService.loadChart(this.scontrinoMedioChart, 'stores.Q107', data, this.indicatorService, this.translate);
      this.show_results = true;
    } else {
      this.data = null;
      this.storeError = true;
    }

  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  resetData() {
    this.show_results = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/store/store-customers/store-customers-loyalty/store-customers-loyalty.component.ts